/**
 * Currencies that do not use decimal places (smallest unit is 1).
 * Used for formatting and price display so amounts are not divided by 100.
 */
export const ZERO_DECIMAL_CURRENCIES: string[] = ['JPY', 'KRW'];

/**
 * Currencies whose symbol is displayed after the amount (e.g. "10 €").
 */
export const CURRENCY_SYMBOLS_AFTER_AMOUNT = new Set(['EUR']);

export enum CurrencySymbol {
  Dollar = '$',
  Pound = '£',
  Euro = '€',
  Rand = 'R',
  Yen = '¥',
  Yuan = 'CN¥',
  Franc = 'CHF',
  Rupiah = 'Rp',
  Ringgit = 'RM',
  HongKongDollar = 'HK$',
  SingaporeDollar = 'S$',
  AustralianDollar = 'A$',
  NewZealandDollar = 'NZ$',
  CanadianDollar = 'C$',
  IndianRupee = '₹',
  KoreanWon = '₩',
  PhilippinePeso = '₱',
  PakistaniRupee = '₨',
  PolishZloty = 'zł',
  SaudiRiyal = '﷼',
}

export const currencyCodeToSymbol: Record<string, CurrencySymbol> = {
  AUD: CurrencySymbol.Dollar,
  NZD: CurrencySymbol.Dollar,
  SGD: CurrencySymbol.Dollar,
  USD: CurrencySymbol.Dollar,
  GBP: CurrencySymbol.Pound,
  EUR: CurrencySymbol.Euro,
  ZAR: CurrencySymbol.Rand,
  HKD: CurrencySymbol.HongKongDollar,
  CAD: CurrencySymbol.CanadianDollar,
  CHF: CurrencySymbol.Franc,
  CNY: CurrencySymbol.Yuan,
  IDR: CurrencySymbol.Rupiah,
  JPY: CurrencySymbol.Yen,
  MYR: CurrencySymbol.Ringgit,
  INR: CurrencySymbol.IndianRupee,
  KRW: CurrencySymbol.KoreanWon,
  PHP: CurrencySymbol.PhilippinePeso,
  PKR: CurrencySymbol.PakistaniRupee,
  PLN: CurrencySymbol.PolishZloty,
  SAR: CurrencySymbol.SaudiRiyal,
};

export type EvidenceCheckoutResponse = {
  checkout_session_url?: string | null;
  subscription_id?: string | null;
  trial_end_date?: string | null;
};
